import { FC } from "react";

import { ArrowRightIcon } from "@/assets/icons";

import ChatListLoadMoreFooter from "../ChatListLoadMoreFooter";
import type { ChatListLoadMore, ChatSearchRow } from "../constants";
import { formatResultCount } from "./formatResultCount";

type Props = {
  query: string;
  total: number;
  isTotalExact: boolean;
  rows: ChatSearchRow[];
  onSelect: (threadId: string) => void;
  loadMore: ChatListLoadMore;
};

const ChatSearchResults: FC<Props> = ({
  query,
  total,
  isTotalExact,
  rows,
  onSelect,
  loadMore
}) => (
  <section className="flex flex-col gap-5">
    <p aria-hidden className="break-words text-xs leading-5 text-txtBody">
      {`${formatResultCount(total, isTotalExact)} for “${query}”`}
    </p>

    <ul className="flex flex-col gap-2">
      {rows.map(({ id, title, preview, timeLabel }) => (
        <li
          key={id}
          className="overflow-hidden rounded-xl border border-gainsboro bg-white"
        >
          <button
            type="button"
            onClick={() => onSelect(id)}
            className="flex w-full items-center gap-6 p-4 text-left transition-colors hover:bg-teal-50"
          >
            <span className="flex min-w-0 flex-1 flex-col gap-1">
              <span className="truncate text-sm font-semibold text-txtHeading">
                {title}
              </span>
              {preview && (
                <span className="truncate text-xs text-txtBody">{preview}</span>
              )}
            </span>
            <span className="shrink-0 text-xs text-txtBody">{timeLabel}</span>
            <ArrowRightIcon
              aria-hidden
              className="size-6 shrink-0 fill-dim-gray"
            />
          </button>
        </li>
      ))}
      <ChatListLoadMoreFooter loadMore={loadMore} />
    </ul>
  </section>
);

export default ChatSearchResults;
